/**************************************************
 * Nombre:       Seccion_Proximamente
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import React, {useEffect} from "react";
import Tarjeta_Producto from "../Tarjetas/Tarjeta_Producto";
import bot from '../../Recursos/bot.png'
import casino from '../../Recursos/casino.png'
import nft from '../../Recursos/nft.png'
import ecommerce from '../../Recursos/ecommerce.png'
import tarjeta from '../../Recursos/tarjeta.png'
import wallet from '../../Recursos/wallet.png'
import {irArriba} from "../../Utilidades/irArriba";


const Seccion_Proximamente = () => {

    useEffect(() => {
        irArriba()
    },[])
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={4}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4, mb: 4}}>
                    <Typography sx={{color: '#fff', fontWeight: 800, fontSize: 32}}>Proximamente</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        {items.map((item, i) => (
                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Producto item={item}/>
                            </Grid>
                        ))}

                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Seccion_Proximamente


const items = [
    {
        nombre: 'Trading Bot',
        descripcion: 'Nuestros bots impulsados por inteligencia artificial analizan en tiempo real los mercados internacionales, identifican oportunidades y ejecutan operaciones de forma automática, maximizando el potencial de rentabilidad con precisión y velocidad.',
        img: bot
    },
    {
        nombre: 'Pool Casino',
        descripcion: 'Pool Casino es un espacio digital donde la diversión se une con la blockchain. Aquí los usuarios pueden jugar, participar en torneos y ganar recompensas directamente en criptomonedas, todo dentro de un entorno seguro y transparente.',
        img: casino
    },
    {
        nombre: 'Tockenizacion de propiedades',
        descripcion: 'La tokenización de propiedades permite transformar bienes físicos en activos digitales respaldados en blockchain. Esto abre el acceso a inversiones seguras, transparentes y fraccionadas, generando nuevas oportunidades de crecimiento patrimonial.',
        img: nft
    },
    {
        nombre: 'Ecommerce con cryptos',
        descripcion: 'El ecommerce con criptomonedas integra la economía digital con el comercio en línea. Los usuarios pueden comprar y vender productos de forma segura, rápida y global, aprovechando la transparencia y eficiencia de la blockchain.',
        img: ecommerce
    },
    {
        nombre: 'Tarjeta Internacional',
        descripcion: 'Nuestra tarjeta internacional conecta tus activos digitales con el mundo real. Te permite realizar compras, pagos y retiros en cualquier parte del mundo, transformando tus criptomonedas en liquidez inmediata de forma sencilla y segura.',
        img: tarjeta
    },
    {
        nombre: 'Wallet y token Bitnova',
        descripcion: 'La wallet BitNova ofrece un espacio seguro para almacenar, enviar y recibir criptomonedas, mientras que nuestro token propio impulsa el ecosistema, facilitando transacciones, recompensas y nuevas oportunidades dentro de la plataforma.',
        img: wallet
    },
]